import { useState } from "react";

import useService from "../../../../hooks/useService";
import { getModalHandler } from "../../Common/Modals/hooks/useModalSingleton";

export default function useEventHandlers({ fetchContractsData, setCurrentPage }) {
  const contractsRepository = useService("repositories/contracts-repository");
  const { openFailureModal, openSuccessModal } = getModalHandler();
  const [modalState, setModalState] = useState({ mode: "", contract: null });
  const [isDeleting, setIsDeleting] = useState(false);

  const handlePageChange = (_, newPage) => setCurrentPage(newPage);
  const handleOpenAddModal = () => setModalState({ mode: "add", contract: null });
  const handleOpenEditModal = (contract) => setModalState({ mode: "edit", contract });
  const handleOpenDeleteModal = (contract) => setModalState({ mode: "delete", contract });
  const handleCloseModal = () => setModalState({ mode: "", contract: null });
  const handleDelete = async () => {
    const contractId = modalState.contract?.id;

    if (!contractId) {
      return;
    }

    try {
      setIsDeleting(true);
      await contractsRepository.delete(contractId);
      await fetchContractsData?.();
      handleCloseModal();
      openSuccessModal();
    } catch (error) {
      openFailureModal(error);
    } finally {
      setIsDeleting(false);
    }
  };

  return {
    modalState,
    isDeleting,
    handleDelete,
    handlePageChange,
    handleOpenAddModal,
    handleOpenEditModal,
    handleOpenDeleteModal,
    handleCloseModal,
  };
}

export function useContractsRowMenuHandlers({ data, onDelete, onEdit }) {
  const [anchorEl, setAnchorEl] = useState(null);
  const menuOpen = Boolean(anchorEl);

  const handleMenuOpen = (event) => setAnchorEl(event.currentTarget);
  const handleMenuClose = () => setAnchorEl(null);
  const handleEdit = () => {
    handleMenuClose();
    onEdit(data);
  };
  const handleDelete = () => {
    handleMenuClose();
    onDelete(data);
  };

  return {
    anchorEl,
    menuOpen,
    handleMenuOpen,
    handleMenuClose,
    handleEdit,
    handleDelete,
  };
}
